export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const SET_USER = "SET_USER";
export const SET_COMPANY = "SET_COMPANY";

export const MESSAGE_SUCCES = "Success";
export const MESSAGE_INFO = "Warning";
export const MESSAGE_ERROR = "Danger";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const SHOW_MODAL = "SHOW_MODAL";
export const SHOW_MODAL_PRODUCTRESERVATION = "SHOW_MODAL_PRODUCTRESERVATION";
export const SHOW_MODAL_CANCELMYPRODUCTRESERVATION = "SHOW_MODAL_CANCELMYPRODUCTRESERVATION";
export const SHOW_MODAL_COMPANY_CONNECT_WITH_CODE = "SHOW_MODAL_COMPANY_CONNECT_WITH_CODE";
export const SHOW_MODAL_COMPANY_PROVIDER_REQUEST = "SHOW_MODAL_COMPANY_PROVIDER_REQUEST";
export const SHOW_MODAL_PRODUCT_LOCATION = "SHOW_MODAL_PRODUCT_LOCATION";
export const SHOW_REMOVE_MODAL = "SHOW_REMOVE_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";

export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";

export const SHOW_MAINMENU = "SHOW_MAINMENU";
export const HIDE_MAINMENU = "HIDE_MAINMENU";

export const showLoader=(showMenu, leftButtons) => (dispatch) => {
	let dispatchObj = { type: SHOW_LOADER}
	if(showMenu == true || showMenu == false) {
		dispatchObj["showmenu"] = showMenu;
	}
	if(leftButtons) {
		dispatchObj["leftButtons"] = leftButtons;
	}
  dispatch(dispatchObj);
};

export const hideLoader = () => (dispatch) => {
  dispatch({
    type: HIDE_LOADER,
  });
};

